import { UiIcon, UiText } from 'znanie-uikit';

import css from './PosterDate.module.scss';

interface IProps {
  place: string;
  isOffline: boolean;
}

export default function Location({ place, isOffline }: IProps) {
  // если мероприятие проходит оффлайн, отображаем только иконку и место проведения (если место проведения указано)
  const offlineContent = place && (
    <div>
      <UiIcon name="location" />
      <UiText className={css.locationText} as="span" color="white">
        {place}
      </UiText>
    </div>
  );

  // если мероприятие проходит онлайн, то отображаем слово "Онлайн" и иконку
  const onlineContent = (
    <div>
      <UiIcon name="global" />
      <UiText className={css.locationText} as="span" color="white">
        Онлайн
      </UiText>
    </div>
  );

  return (
    <div className={css.location}>
      {isOffline ? offlineContent : onlineContent}
    </div>
  );
}
